<template>
  <ul class="list-group">
    <li
      @click="$emit('on-detail', t)"
      class="list-group-item d-flex align-items-center"
      v-for="(t, i) in tasks"
      :key="i"
      role="button"
    >
      <div class="avatar">
        <span
          v-if="!t.isCompleted"
          :class="`avatar-initial rounded-circle bg-transparent bd bd-gray-900`"
        >
          <feather
            type="help-circle"
            class="tx-color-02"
            style="margin-top: -4px; width: 19px; height: 19px;"
          ></feather>
        </span>
        <span
          v-else
          :class="`avatar-initial rounded-circle bg-success bd bd-success`"
        >
          <feather
            type="check-square"
            class="tx-color-02"
            style="margin-top: -4px; width: 19px; height: 19px;"
          ></feather>
        </span>
      </div>
      <div class="pd-l-10">
        <h6 class="tx-13 tx-semibold mg-b-0">{{ t.task }}</h6>
        <span class="d-block tx-11 text-muted">хариулт харах</span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style></style>
